import { render, staticRenderFns } from "./UserName.vue?vue&type=template&id=0a168219&scoped=true&"
import script from "./UserName.vue?vue&type=script&lang=ts&"
export * from "./UserName.vue?vue&type=script&lang=ts&"
import style0 from "./UserName.vue?vue&type=style&index=0&id=0a168219&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a168219",
  null
  
)

export default component.exports